"use strict";

/*const form = document.querySelector("form");
const firstName = document.querySelector('input[name="fName"]');
const lastName = document.querySelector('input[name="sName"]');
const email = document.getElementById("email");
const requirement = document.getElementById("requirement");

form.addEventListener("submit", (e) => {
  e.preventDefault();
  validateInputs();
});

const setError = (element, message) => {
  const inputControl = element.parentElement;
  const errorDisplay = inputControl.querySelector(".error");
  errorDisplay.innerText = message;
  inputControl.classList.add("error");
  inputControl.classList.remove("success");
};

const setSuccess = (element) => {
  const inputControl = element.parentElement;
  const errorDisplay = inputControl.querySelector(".error");
  errorDisplay.innerText = "";
  inputControl.classList.add("success");
  inputControl.classList.remove("error");
};

const validEmail = (email) => {
  const reg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(String(email).toLowerCase());
};

const validateInputs = () => {
  const firstNameValue = fName.value.trim();
  const lastNameValue = sName.value.trim();
  const emailValue = email.value.trim();
  const requirementValue = requirement.value.trim();

  if (firstNameValue === "") {
    setError(fName, "Oops, we do need you first name");
  } else {
    setSuccess(fName);
  }

  if (lastNameValue === "") {
    setError(sName, "Oops, we do need your last name");
  } else {
    setSuccess(sName);
  }

  if (emailValue === "") {
    setError(email, "Your email please");
  } else if (!validEmail(emailValue)) {
    setError(email, "Please provide a valid email address");
  } else {
    setSuccess(email);
  }

  if (requirementValue === "") {
    setError(requirement, "Please specify your requirements");
  } else {
    setSuccess(requirement);
  }
};*/

const form = document.querySelector("form");
const firstName = document.querySelector('input[name="fName"]');
const lastName = document.querySelector('input[name="sName"]');
const email = document.getElementById("email");
const requirement = document.getElementById("requirement");

form.addEventListener("submit", (e) => {
  e.preventDefault();
  validateInputs();
});

const setError = (element, message) => {
  const inputControl = element.parentElement;
  const errorDisplay = inputControl.querySelector(".error");
  errorDisplay.innerText = message;
  inputControl.classList.add("error");
  inputControl.classList.remove("success");
};

const setSuccess = (element) => {
  const inputControl = element.parentElement;
  const errorDisplay = inputControl.querySelector(".error");
  errorDisplay.innerText = "";
  inputControl.classList.add("success");
  inputControl.classList.remove("error");
};

const validEmail = (email) => {
  const reg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(String(email).toLowerCase());
};

const validateInputs = () => {
  const firstNameValue = fName.value.trim();
  const lastNameValue = sName.value.trim();
  const emailValue = email.value.trim();
  const requirementValue = requirement.value.trim();

  if (firstNameValue === "") {
    setError(fName, "Oops, we do need you first name");
  } else {
    setSuccess(fName);
  }

  if (lastNameValue === "") {
    setError(sName, "Oops, we do need your last name");
  } else {
    setSuccess(sName);
  }

  if (emailValue === "") {
    setError(email, "Your email please");
  } else if (!validEmail(emailValue)) {
    setError(email, "Please provide a valid email address");
  } else {
    setSuccess(email);
  }

  if (requirementValue === "") {
    setError(requirement, "Please specify your requirements");
  } else {
    setSuccess(requirement);
  }
};
const handleSubmit = (event) => {
  event.preventDefault();

  const myForm = event.target;
  const formData = new FormData(myForm);

  fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(formData).toString(),
  })
    .then(() => alert("Thank you for your submission"))
    .catch((error) => alert(error));
  validateInputs();

  myForm.reset();
};

document.querySelector("form").addEventListener("submit", handleSubmit);
